import BaseModel from "lib/model";

export default BaseModel.extend({
    props: {
        __method: { type: "string", required: true },
        __uri: { type: "string", required: true },
        __key: { type: "string" },
        __display_name: { type: "string" },
        __body: { type: "object" },
        __headers: { type: "object" },
    },
});
